import {commonAdminQueries} from '@common/admin/common-admin-queries';
import {authGuard} from '@common/auth/guards/auth-route';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {searchParamsFromUrl} from '@ui/utils/urls/search-params-from-url';
import {RouteObject} from 'react-router';

export const adminFileDownloadsRoutes: Record<string, RouteObject> = {
  index: {
    path: 'forensics',
    shouldRevalidate: shouldRevalidateDatatableLoader,
    lazy: () =>
      import('@common/admin/file-downloads/file-downloads-index-page'),
    loader: ({request}) => {
      // forensic log is super-admin only (matches the isAdmin backend guard)
      const redirect = authGuard({permission: 'admin'});
      if (redirect) return redirect;
      return queryClient.ensureQueryData(
        commonAdminQueries.fileDownloads.index(
          searchParamsFromUrl(request.url),
        ),
      );
    },
  },
  // Legacy `/admin/downloads` URLs (older bookmarks, the original sidebar
  // entry that lived for a few days, in-product links) redirect to the
  // renamed route so they don't 404. Safe to remove once the wider menu DB
  // migration is several weeks old.
  legacyRedirect: {
    path: 'downloads',
    loader: () => {
      throw new Response(null, {
        status: 302,
        headers: {Location: '/admin/forensics'},
      });
    },
  },
};
